import { connect } from 'react-redux'
import { sagaActions } from 'store/sagas'
import SPUserPicker from './SPUserPicker'

export default connect(
  (state, props) => {
    return {
      users: state.kanbo.spUsers.users,
      usersByProfileKey: state.kanbo.spUsers.usersByProfileKey,
      loading: state.kanbo.spUsers.loading,
      loaded: state.kanbo.spUsers.loaded
    }
  },
  {
    fetchSPUsers: sagaActions.fetchSPUsers
  },
  null,
  {
    forwardRef: true
  }
)(SPUserPicker)

